import React, {Fragment, useState} from "react";

// components
import MassiveActions from "./MassiveActions";
import OrdersGrid from "../../../Common/Orders/OrdersGrid";
import HeaderActions from "../../Navigation/HeaderActions";
import {Order} from "../../../../types/orders/order";
import { useElsewhereEmpty } from "../../../Common/Orders/useElsewhereEmpty";

interface Props {
  tableData: Order[];
  fetchingOrders: boolean;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: any
  featuresAllowed: string[];
}

const NO_REJECTED = "No hay envíos rechazados en este rango";

export default (props: Props) => {
  const initialSortValue = [
    { field: null, dir: null },
  ];
  const [sort, setSort] = useState(initialSortValue);
  const empty = useElsewhereEmpty("rejected_orders", NO_REJECTED, props.activeFilters.filter, !props.fetchingOrders && props.total === 0);

  return (
      <Fragment>
        <HeaderActions>
          <MassiveActions
              orders={props.tableData}
              total={props.total}
              requestNewPage={props.sendFilters}
          />
        </HeaderActions>
        <OrdersGrid
            tableData={props.tableData}
            loading={props.fetchingOrders}
            requestNewPage={props.sendFilters}
            take={props.take}
            skip={props.skip}
            total={props.total}
            sort={sort}
            setSort={setSort}
            featuresAllowed={props.featuresAllowed}
            empty={empty}
        />
      </Fragment>
  );
};
